import { render, staticRenderFns } from "./plist.vue?vue&type=template&id=e2ec1a72"
import script from "./plist.vue?vue&type=script&lang=js"
export * from "./plist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports